package co.maytes.standupbot.dashboard.features.settings

import co.maytes.standupbot.dashboard.components.widgets.icons.LucideBuilding
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideCreditCard
import co.maytes.standupbot.dashboard.components.widgets.icons.LucidePlug
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideScrollText
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideShield
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideTag
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideTerminal
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideUser
import co.maytes.standupbot.dashboard.components.widgets.icons.LucideUsers
import co.maytes.standupbot.dashboard.features.settings.sections.AuditLogSection
import co.maytes.standupbot.dashboard.features.settings.sections.BillingSection
import co.maytes.standupbot.dashboard.features.settings.sections.DataSection
import co.maytes.standupbot.dashboard.features.settings.sections.GeneralSection
import co.maytes.standupbot.dashboard.features.settings.sections.IntegrationsSection
import co.maytes.standupbot.dashboard.features.settings.sections.LogsSection
import co.maytes.standupbot.dashboard.features.settings.sections.MembersSection
import co.maytes.standupbot.dashboard.features.settings.sections.ProfileSection
import co.maytes.standupbot.dashboard.features.settings.sections.ReleasesSection

val settingsRegistry: List<SettingsSection> = listOf(
    SettingsSection(
        spec = SettingsCatalog.page("profile"),
        icon = { color -> LucideUser(size = SECTION_ICON, strokeColor = color) },
        content = { ProfileSection() },
    ),
    SettingsSection(
        spec = SettingsCatalog.page("general"),
        icon = { color -> LucideBuilding(size = SECTION_ICON, strokeColor = color) },
        content = { GeneralSection() },
    ),
    SettingsSection(
        spec = SettingsCatalog.page("members"),
        icon = { color -> LucideUsers(size = SECTION_ICON, strokeColor = color) },
        content = { MembersSection() },
    ),
    SettingsSection(
        spec = SettingsCatalog.page("integrations"),
        icon = { color -> LucidePlug(size = SECTION_ICON, strokeColor = color) },
        content = { IntegrationsSection() },
    ),
    SettingsSection(
        spec = SettingsCatalog.page("releases"),
        icon = { color -> LucideTag(size = SECTION_ICON, strokeColor = color) },
        content = { ReleasesSection() },
    ),
    SettingsSection(
        spec = SettingsCatalog.page("billing"),
        icon = { color -> LucideCreditCard(size = SECTION_ICON, strokeColor = color) },
        content = { BillingSection() },
    ),
    SettingsSection(
        spec = SettingsCatalog.page("data"),
        icon = { color -> LucideShield(size = SECTION_ICON, strokeColor = color) },
        content = { DataSection() },
    ),
    SettingsSection(
        spec = SettingsCatalog.page("audit-log"),
        icon = { color -> LucideScrollText(size = SECTION_ICON, strokeColor = color) },
        content = { AuditLogSection() },
    ),
    SettingsSection(
        spec = SettingsCatalog.page("logs"),
        icon = { color -> LucideTerminal(size = SECTION_ICON, strokeColor = color) },
        content = { LogsSection() },
    ),
)

private const val SECTION_ICON = 16
